{ logoDomain, siteDomain } = require '@trello/config'
Auth = require 'app/scripts/db/auth'
t = require('./teacup-with-helpers')()
templates = require 'app/scripts/views/templates'
_ = require 'underscore'

methods =
  mustacheRenderWithHelpers: (body, data, opts = {}, partials = {}) ->
    args = _.extend {
      __ed: opts.editable
      __own: opts.owned
      __loggedIn: Auth.isLoggedIn()
      __siteDomain: siteDomain
      __logoDomain: logoDomain
    }, data

    t.mustacheRender body, args, partials

  mustacheRenderModel: (body, model, data, partials = {}) ->
    opts = { editable: model.editable?(), owned: model.owned?() }
    data = _.extend(model.toJSON(), data)
    methods.mustacheRenderWithHelpers body, data, opts, partials

  fill: (path, data = {}, opts = {}, partials = {}) ->
    template = templates[path]
    if !template?
      throw new Error("Could not find template #{path}!")
    methods.mustacheRenderWithHelpers(template, data, opts, partials)

  fillFromModel: (path, model, data = {}, partials = {}) ->
    template = templates[path]
    if !template?
      throw new Error("Could not find template #{path}!")
    methods.mustacheRenderModel(template, model, data, partials)

  fillMenu: (s, o, opts) ->
    methods.fill 'menu_base', { content: @fill(s, o, opts) }

module.exports = require('proto-extend')(templates, methods)
